import React from 'react';
import axios from 'axios';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import AxiosConfig from '../../../utilities/AxiosConfig';
import { CodeType, DepartmentReferenceType, TimeEntryType } from '../../../pages/company_operations/time_administration/types';
import IconButton from '../../common/IconButton';
import snackBar from '../../../utilities/snackBar/SnackBar';
import dayjs from 'dayjs';
import { AppState } from 'src/store';
import { connect } from 'react-redux';

export interface IProps {
    roles: AppState["user"]["roles"];
    departmentId: string;
    departments: any;
    open: boolean;
    closeModal: any;
    date?: any;
    toEdit?: any;
    refreshEmployee: any;
    employeeId: string | number;
    inUsePC?: any;
}

const AddTime: React.FC<IProps> = (props: IProps) => {
    const { departmentId, closeModal, open, toEdit, inUsePC } = props;
    const [newTime, setNewTime] = React.useState(toEdit ? toEdit : {
        ApprovedBy: null,
        ApprovedDate: null,
        Category: null,
        CodeDescription: null,
        Comment: "",
        CreatedBy: 0,
        CreatedDate: "",
        DayOfWeek: "",
        DeletedDate: null,
        DeletedBy: "",
        DepartmentId: 0,
        DisabledBy: 0,
        DisabledDate: null,
        EmployeeId: props.employeeId,
        EmployeeName: "",
        EnteredFieldTimeCodeId: 0,
        EntryDate: dayjs(props.date).format("MM/DD/YYYY"),
        FieldTimeCodeId: 0,
        IsApproved: false,
        IsDisputed: false,
        IsOutOfPC: false,
        ModifiedBy: 0,
        ModifyDate: null,
        PayrollExportDate: null,
        Quantity: 0,
        TimeEntryId: 0,
    } as any);
    const [codes, setCodes] = React.useState(null as any);
    const [allDepartments, setAllDepartments] = React.useState([]);
    const [loadingDept, setLoadingDept] = React.useState(false);
    const [loadingCodes, setLoadingCodes] = React.useState(false);
    const inUseHrCode: any = React.useRef(null);

    const filteredCodes = codes?.filter((code: CodeType) => {
        if (code._codeDescription === "PTO Payout") {
            return props.roles.includes("HR User");
        }
        return true;
    })
    //console.log("Mapped Codes ", filteredCodes)
    const addTime = async () => {
        const rb: TimeEntryType | null = newTime;
        if (rb) { rb.ProfitCenterId = inUsePC; }
        //cgm100322==> added the timeCodeDescription as you can't check based on ID for PTO Payout.  There are numerous IDs associated with each time code
        const timeCodeDescription = codes?.find((code: CodeType) => code._fieldTimeCodeID === newTime.FieldTimeCodeId)?._codeDescription
        //console.log("Request Body: ", rb, timeCodeDescription, props.roles.includes("HRAdmin"), props.roles);
        if (timeCodeDescription === "PTO Payout" && !props.roles.includes("HR User")) {
            snackBar({ text: "Only an HR User may select PTO Payout", type: "error", timeout: 2000 })
            return;
        }
        if (timeCodeDescription !== "PTO Payout") {
            if (Number(rb?.Quantity) % 0.25 !== 0) {
                snackBar({ text: "Quantity must be in quarter hour increments.", type: "custom", timeout: 2000 }, {
                    bg: "#dc3545",
                    color: "#fff",
                    zIndex: 1022
                });
                return;
            }
        }
        //@ts-ignore
        //console.log("value:::", window.TimeAdminDetailTotal, toEdit?.Quantity || 0, Number(newTime.Quantity), (window.TimeAdminDetailTotal - (toEdit?.Quantity || 0) + Number(newTime.Quantity)));
        //@ts-ignore  cgm100322==> time code descrtiption check for PTO Payout added as they need to be able to request all time on a payout.
        if ((window.TimeAdminDetailTotal - (toEdit?.Quantity || 0) + Number(newTime.Quantity)) > 24 && timeCodeDescription !== "PTO Payout") {
            snackBar({ text: "Total hours cannot exceed 24 hours for the day.", type: "error", timeout: 2000 })
            return;
        }
        if (Number(rb?.Quantity) > -1 && Number(rb?.FieldTimeCodeId) > 0 && Number(rb?.DepartmentId) > -1) {
            axios.post(process.env.REACT_APP_API_URL + "/api/timeadmin/addedittimeentry", rb, AxiosConfig.configValue("min"))
                .then((res: any) => {
                    //console.log("RES: ", res);
                    if (AxiosConfig.checkResponse(res)) {
                        if (res.data.TimeEntry.Validation.IsValid) {
                            props.refreshEmployee();
                        } else {
                            snackBar({ type: "error", text: res.data.TimeEntry.Validation.ValidationMessages[0].Item2 || "There was an error processing your request.", timeout: 3000 })
                        }
                    }
                })
                .catch((err: any) => {
                    //console.log(err, err.response);
                })
                .finally(() => { })
        } else {
            snackBar({ text: "Missing field or invalid Quantity detected. Cannot add time.", type: "error", timeout: 2000 })
        }
    }

    const getTimeCodes = (timeEntry: any = null) => {
        setLoadingCodes(true);
        axios.get(process.env.REACT_APP_API_URL + `/api/timeadmin/getfieldtimecodes/${timeEntry ? timeEntry.DepartmentId : departmentId}`, AxiosConfig.configValue("min"))
            .then((res: any) => {
                //console.log("RES: ", res);
                if (AxiosConfig.checkResponse(res)) {
                    setCodes(res.data.codes);
                    //console.log("In Use HR Code: ", inUseHrCode.current, res.data.codes);
                    if (newTime.FieldTimeCodeId === 0 && inUseHrCode.current === null && timeEntry) {
                        setNewTime(timeEntry);
                    }
                    if (inUseHrCode.current === null && newTime.FieldTimeCodeId) {
                        let found: CodeType = res.data.codes.find((code: CodeType) => code._fieldTimeCodeID === newTime.FieldTimeCodeId);
                        //console.log("Found: ", found);
                        if (found) {
                            inUseHrCode.current = found._hrTimeCodeID;
                            if (timeEntry) {
                                setNewTime(timeEntry);
                            }
                        }
                    } else if (inUseHrCode.current !== null) {
                        let found: CodeType = res.data.codes.find((code: CodeType) => code._hrTimeCodeID === inUseHrCode.current);
                        //console.log("Found: ", found);
                        if (found) {
                            //console.log("Value of newTime: ", newTime);
                            setNewTime({ ...timeEntry, FieldTimeCodeId: found._fieldTimeCodeID });
                        }
                    }
                }
            })
            .catch((err: any) => {
                //console.log("ERR: ", err);
                AxiosConfig.handleError(err);
            })
            .finally(() => { setLoadingCodes(false); })
    }

    const handleTimeCodeChange = (val: any) => {
        if (val?.value) {
            let found: CodeType | null = codes.find((code: CodeType) => code._fieldTimeCodeID === val.value);
            if (found) {
                inUseHrCode.current = found._hrTimeCodeID
            }
        } else if (!val) {
            inUseHrCode.current = null;
        }
        setNewTime({ ...newTime, FieldTimeCodeId: val?.value });
    }

    const handleDeptChange = (val: any) => {
        //console.log("Handle Change", val);
        let newTimeEntry: any = { ...newTime, DepartmentId: val?.value, FieldTimeCodeId: toEdit?.TimeEntryId ? 0 : newTime.FieldTimeCodeId };
        //console.log("NewTimeEntry ", newTimeEntry)
        getTimeCodes(newTimeEntry);
    }

    React.useEffect(() => {
        if (!open) { return; }
        // if(toEdit?.TimeEntryId){
        // alert("Loading all departments");
        //console.log("Loading all departments")
        setLoadingDept(true);
        axios.get(process.env.REACT_APP_API_URL + "/api/timeadmin/reference", AxiosConfig.configValue("min"))
            .then(res => {
                AxiosConfig.checkResponse(res);
                //console.log("REsponse from reference: ", res.data.departments);
                setAllDepartments(res.data.departments);
            })
            .catch(err => {
                //console.log(err, err.response);
            })
            .finally(() => { setLoadingDept(false); })
        // }
        getTimeCodes();
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [open, departmentId])

    React.useEffect(() => { inUseHrCode.current = null; }, [open])

    const customStyles = {
        menuList: (provided: any) => ({ ...provided, height: 150, overflowY: "scroll" })
    }

    if (!open) { return null }
    return (
        <div onClick={(e: any) => { e.preventDefault(); closeModal(); }} className="text-preview-modal">
            <div onClick={(e: any) => e.stopPropagation()} className="py-4 w-60 bg-white"
                style={{ marginTop: 20, overflowY: "scroll", minHeight: 350 }}>
                <label style={{ marginLeft: 15 }} className="font-weight-bold">Department</label>
                <Select
                    isMulti={false}
                    onChange={handleDeptChange}
                    isLoading={loadingDept}
                    options={
                        // !toEdit?.TimeEntryId
                        // ? departments?.map((dept: DepartmentReferenceType) => ({ label: dept.Description, value: dept.DepartmentId })).sort((a: any, b: any) => a.label.localeCompare(b.label)) || []
                        // : 
                        allDepartments.map((dept: DepartmentReferenceType) => ({ label: dept.DisplayName, value: dept.DepartmentId })).sort((a: any, b: any) => a.label.localeCompare(b.label))
                    }
                    value={
                        newTime.DepartmentId
                            ?
                            // !toEdit?.TimeEntryId
                            //     ? 
                            // {label: departments.find((d: DepartmentReferenceType) => d.DepartmentId === newTime.DepartmentId)?.Description, value: newTime.DepartmentId} 
                            //@ts-ignore
                            // : 
                            { label: allDepartments.find((d: DepartmentReferenceType) => d.DepartmentId === newTime.DepartmentId)?.DisplayName || "", value: newTime.DepartmentId }
                            : null}
                    className="col-sm-12"
                    placeholder="Department"
                    styles={customStyles}
                />
                <label style={{ marginLeft: 15 }} className="font-weight-bold">Time Code</label>
                <Select
                    isMulti={false}
                    onChange={handleTimeCodeChange}
                    label="Time Code"
                    // options={codes ? codes.map((code: CodeType) => ({ label: code._codeDescription, value: code._fieldTimeCodeID })) : []} 
                    options={filteredCodes ? filteredCodes.map((code: CodeType) => ({ label: code._codeDescription, value: code._fieldTimeCodeID }))
                        :
                        []
                    }
                    className="col-sm-12"
                    placeholder="Time Code"
                    isLoading={loadingCodes}
                    isDisabled={newTime.DepartmentId <= 0 || loadingCodes}
                    value={newTime.FieldTimeCodeId
                        ? { value: newTime.FieldTimeCodeId, label: codes?.find((code: CodeType) => code._fieldTimeCodeID === newTime.FieldTimeCodeId)?._codeDescription }
                        : null
                    }
                    styles={customStyles}
                />
                <div className="col-sm-12 my-3" style={{ padding: "0px 15px" }}>
                    <label className="font-weight-bold">Quantity</label>
                    <Form.Control
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            e.preventDefault();
                            setNewTime({ ...newTime, Quantity: e.target.value });
                        }}
                        value={newTime.Quantity}
                        type="number"
                        placeholder="Quantity" />
                </div>
                <div className="d-flex flex-row align-items-center justify-content-end mt-1">
                    <IconButton buttonClassName="action-text mt-5" onClick={(e: React.SyntheticEvent) => { e.preventDefault(); closeModal(); }} icon="cancel">Close</IconButton>
                    <IconButton buttonClassName="action-text mt-5" onClick={(e: React.SyntheticEvent) => { e.preventDefault(); addTime(); }} icon={toEdit ? "save" : "add"}>
                        {toEdit ? "Save Changes" : "Add Time"}
                    </IconButton>
                </div>
            </div>
        </div>
    );
}

AddTime.defaultProps = {
    toEdit: null,
    date: null,
}

const mapStateToProps = (state: AppState) => ({
    roles: state.user.roles,
    UserSettings: state.user.UserSettings
})

export default connect(mapStateToProps)(AddTime);